import rangePlugin from 'flatpickr/dist/plugins/rangePlugin'
import moment from 'moment'
import flatpickr from 'flatpickr'
import { getSurroundingDates } from '@/helpers/getSurroundingDates.js'
import debugLogScriptName from '@/debug-log-script-name'

$(function() {
  $('body').on('bless', function(e) {
    const $flatpickrs = $('.flatpickr')
    debugLogScriptName($flatpickrs, 'flatpickr.js') // DEBUG
    $flatpickrs.each(function() {
      const $el = $(this)
      /* The following hack for `altInputClass` is needed because of a bug in flatpickr where the original classes are removed */
      const options = {
        altInput: true,
        altInputClass: 'form-element flatpickr-input picker-input-field',
        dateFormat: 'YYYY-MM-DD',
        altFormat: 'L',
        allowInput: true,
        parseDate: (dateString, format) => {
          return moment(dateString, format, true).toDate()
        },
        formatDate: (date, format, _) => {
          return moment(date).format(format)
        },
        locale: {
          firstDayOfWeek: moment.localeData(window.i18n.locale).firstDayOfWeek(),
        },
      }

      const flatpickrExists =
        $el[0] && ($el[0]._flatpickr || $el[0].classList.contains(options.altInputClass))
      if (flatpickrExists) {
        return
      }

      if ($el.attr('limit-date-range')) {
        options.onChange = function(selectedDates, dateStr, instance) {
          if (selectedDates.length === 1) {
            instance.set(
              'enable',
              getSurroundingDates({
                currentDate: dateStr,
                daysLimit: $el.attr('limit-date-range'),
              }),
            )
          } else {
            instance.set('enable', [])
          }
        }
      }

      /*
       * This code preventing bug in the payments where payment is opened. The payment slide from right block triggers on
       * bless founds all inputs with .flatpickr including the ones previosly created by the flatpickr it self.
       */
      if (typeof $el.attr('name') === 'undefined') {
        return
      }

      if ($el.is('#planboard-date-input')) {
        options.altFormat = 'dddd L'
      }

      if ($el.attr('data-range-mode') === 'multiInput') {
        options.plugins = [new rangePlugin({ input: $el.attr('data-range-end') })]
      }

      if ($el.attr('data-wrap') === 'true') {
        options.wrap = true
      }
      
      if ($el.attr('data-disabled-dates')) {
        const disabled = $el.attr('data-disabled-dates').replace(/\s/g, '')
        const disabledDates = disabled.split(',')
        if (!disabledDates) return 
        options.disable = disabledDates
      }

      if ($el.attr('data-max-date')) {
        const maxDate = $el.attr('data-disabled-dates')
        if (!maxDate.includes('-')) return
        options.maxDate = maxDate
      }

      let datePicker
      if (typeof $el.flatpickr === 'function') {
        // for unknown reasons, $el.flatpickr suddenly doesnt exist anymore as a function on $el
        // presumably by some change in sprint 69
        datePicker = $el.flatpickr(options)
      } else {
        if (process.env.NODE_ENV === 'development')
          console.warn('todo: figure out why flatpickr suddenly is not longer a function on $el')
        datePicker = flatpickr('.flatpickr', options)
      }

      const dates = []
      if ($el.attr('data-value-from')) {
        dates.push($el.attr('data-value-from'))
      }
      if ($el.attr('data-value-to')) {
        dates.push($el.attr('data-value-to'))
      }
      if (dates.length > 0) {
        datePicker.setDate(dates)
      }
    })

    const $target = $(e.target)
    const $changeDateButtons = $target.is('[data-change-date]')
      ? $target
      : $target.find('[data-change-date]')

    $changeDateButtons.on('click', function(e) {
      const $el = $(this)
      const $targetElement = $($el.attr('data-target')).get(0)
      const date = $el.attr('data-change-date')
      $targetElement._flatpickr.setDate(date, true)

      e.preventDefault()
    })
  })
})
